import api from "../../Http/global-vars";

export const getData = async (url, token) => {
  const res = await fetch(`${api}${url}`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  });

  const data = await res.json();
  return data;
};

export const getDataByID = async (url, id, token) => {
  const res = await fetch(`${api}${url}/${id}/`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  });

  const data = await res.json();
  return data;
};

export const postData = async (url, post, token) => {
  // console.log('url', api)
  const res = await fetch(`${api}${url}`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: post instanceof FormData ? post : JSON.stringify(post),
  });
  const data = await res.json();
  return data;
};

export const putData = async (url, post, token) => {
  const res = await fetch(`${api}${url}`, {
    method: "PUT",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: post instanceof FormData ? post : JSON.stringify(post),
  });
  const data = await res.json();
  return data;
};

export const patchData = async (url, post, token) => {
  const res = await fetch(`${api}${url}`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
    body: JSON.stringify(post),
  });

  const data = await res.json();
  return data;
};

export const deleteData = async (url, token) => {
  const res = await fetch(`${api}${url}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  });
  const data = await res;
  return data;
};
